import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { authManagementService } from '@aviv-pro-navigation/authentication-core';
import { from, Observable, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { ReferenceService } from '../services/reference.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  checkAuthPromise;

  constructor(private referenceService: ReferenceService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(
      catchError(err => {
        if (err instanceof HttpErrorResponse && err.status === 401) {
          // Avoid relaunch a promise
          if (!this.checkAuthPromise) {
            this.checkAuthPromise = authManagementService.checkSession();
          }
          return from(this.checkAuthPromise).pipe(
            tap(_ => this.checkAuthPromise = null),
            switchMap(() => next.handle(request)),
            catchError(() => {
              window.location.href = this.referenceService.staticReferences.DuoDomain;
              return throwError('Unauthorized error');
            })
          );
        }
        throw err;
      }),
    );
  }
}
